module.exports = __webpack_public_path__ + "static/media/Caspian.435c195a.svg";